import { render, staticRenderFns } from "./HealthInsuranceSelect.vue?vue&type=template&id=7c8a0538&"
import script from "./HealthInsuranceSelect.vue?vue&type=script&lang=ts&"
export * from "./HealthInsuranceSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
installComponents(component, {VAutocomplete})
